module.exports = __webpack_public_path__ + "img/mapWelcomePage.bd03bce4.png";